import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

export const authGuard: CanActivateFn = () => {
  const oauthService = inject(OAuthService);
  const hasAccessToken = oauthService.hasValidAccessToken();

  if (hasAccessToken) {
    return false;
  }

  return true;
};
